import { useAuthStore } from '@/store/auth.pinia';

/**
 * Use it to get the baseUrl for your request
 */
export function getBaseUrl(): string {
  return `${`https://${useAuthStore().host}`}${import.meta.env.VITE_API_URL}`;
}
